import React from 'react'
import { Outlet } from 'react-router-dom'

const HiraPage = () => {
  return (
    <Outlet />
  )
}

export default HiraPage